import { FC, useMemo } from "react";
import { CollapsedFields } from "../../../../components/GeneralUI/CollapsedFields/CollapsedFields";
import { AttributeGroupWrapper } from "../../detailedPages/AttributeGroupWrapper";
import { capitalize } from "../../../../helpers/string/capitalize";
import { VoidFunc } from "../../../../helpers/functions/types";
import { BadgesWithInput } from "./BadgesWithInput";

export type BadgedInputProps = {
  customActiveData: string[];
  currentActiveData: string[];
  handleBadgedData: VoidFunc<string[]>;
  predefinedValuesGroups?: { [p: string]: string[] };
  inputPlaceholder: string;
};

export const ATTRIBUTE_GROUP_STYLES = "p-2 dark:border-stone-800 dark:border-t";

export const BadgesGroupsWithInput: FC<BadgedInputProps> = ({
  customActiveData,
  currentActiveData,
  handleBadgedData,
  predefinedValuesGroups,
  inputPlaceholder,
}) => {
  const actualCustomData = useMemo(
    () => customActiveData.filter((item) => item.trim() !== ""),
    [customActiveData],
  );

  return (
    <div className="w-full col-span-2 grid gap-2 mb-2">
      <CollapsedFields
        active={true}
        title={`Custom (${actualCustomData.length})`}
      >
        <BadgesWithInput
          actualCustomData={actualCustomData}
          currentActiveData={currentActiveData}
          handleBadgedData={handleBadgedData}
          inputPlaceholder={inputPlaceholder}
        />
      </CollapsedFields>

      {predefinedValuesGroups &&
        Object.entries(predefinedValuesGroups).map(([key, value]) => {
          const checkedAttributesCount = value
            .map((attr) => (currentActiveData ?? []).includes(attr))
            .filter(Boolean).length;
          return (
            <CollapsedFields
              key={key}
              active={checkedAttributesCount > 0}
              title={`${capitalize(key)} (${checkedAttributesCount})`}
              activateFields={() => {
                const newValue = [...new Set([...currentActiveData, ...value])];
                handleBadgedData(newValue);
              }}
              resetFields={() => {
                const newValue = currentActiveData.filter(
                  (item) => !value.includes(item),
                );
                handleBadgedData(newValue);
              }}
            >
              <div className={ATTRIBUTE_GROUP_STYLES}>
                <AttributeGroupWrapper
                  groupAttributesList={value}
                  initAttributesGroup={currentActiveData}
                  handleAttributesGroup={handleBadgedData}
                />
              </div>
            </CollapsedFields>
          );
        })}
    </div>
  );
};
